import React from 'react';

const Form = ({
  children,
  name = 'form',
  formik,
  className = '',
  noValidate = true,
  ...props
}) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        formik.handleSubmit(e);
      }}
      className={className}
      name={name}
      noValidate={noValidate}
      {...props}
    >
      {children}
    </form>
  );
};

export default Form;
